export default "<div class=\"alert\">\r\n  {{ message }}\r\n</div>\r\n"